import type { AgeAnswerModel } from '@home/models/AgeForm.model';
import type { ImprovementAreasModel } from '@quiz/models/ImprovementAreasModel';
import type { IReview, IReviewV3Model } from '@quiz/models/IReview';

export default defineAppConfig({
  growthbookEnabled: true,
  reviewsConfigs: {
    reviews: [1, 2, 3, 4, 5, 6],
    reviewsGoals: [9, 10, 11, 12, 13],

    reviewsList: {
      1: { name: 'Pepsi Zero', title: 'review_1_title', rating: 5, text: 'review_1_text' },
      2: { name: 'Yak', title: 'review_2_title', rating: 5, text: 'review_2_text' },
      3: { name: 'IVBES', title: 'review_3_title', rating: 5, text: 'review_3_text' },
      4: { name: 'ubong inwang', title: 'review_4_title', rating: 5, text: 'review_4_text' },
      5: { name: 'iamtns', title: 'review_5_title', rating: 5, text: 'review_5_text' },
      6: { name: 'g-roh', title: 'review_6_title', rating: 5, text: 'review_6_text' },
      7: { name: 'Chauchooo', title: 'review_7_title', rating: 5, text: 'review_7_text' },
      8: { name: 'JiggySpot', title: 'review_8_title', rating: 5, text: 'review_8_text' },
      81: { name: 'JiggySpot', title: 'review_8_title', rating: 5, text: 'oldTranslations.review81text' },
      9: { name: 'Brown', title: 'review_9_title', rating: 5, text: 'review_9_text' },
      10: { name: 'Amteleronnnnn', title: 'review_10_title', rating: 5, text: 'review_10_text' },
      11: { name: 'Brodaу56', title: 'review_11_title', rating: 5, text: 'review_11_text' },
      12: { name: 'FizzliviSphema', title: 'review_12_title', rating: 5, text: 'review_12_text' },
      13: { name: 'Captain Speedo', title: 'review_13_title', rating: 5, text: 'review_13_text' },
      14: { name: 'Will123Darth368', title: 'review_14_title', rating: 5, text: 'review_14_text' },
      15: { name: 'Hamilton_KingLw33es', title: 'review_15_title', rating: 5, text: 'review_15_text' },
      16: { name: 'IanVital', title: 'review_16_title', rating: 5, text: 'review_16_text' },
      17: { name: 'JackSUN.X0X367', title: 'review_17_title', rating: 5, text: 'review_17_text' },
      18: { name: 'TopicSilly', title: 'review_18_title', rating: 5, text: 'review_18_text' },
      19: { name: 'Neo_Treasure', title: 'review_19_title', rating: 5, text: 'review_19_text' },
      20: { name: 'Armando A.', title: 'review_20_title', rating: 5, text: 'review_20_text' },
    },

    reviewsListV3: {
      1: { name: 'Baltasar Gracián', position: 'scor_review_1_position', title: 'scor_review_1_title' },
      2: { name: 'Charles Kettering', position: 'scor_review_2_position', title: 'scor_review_2_title' },
      3: { name: 'Lord Kelvin', position: 'scor_review_3_position', title: 'scor_review_3_title' },
      4: { name: 'Richard Branson', position: 'scor_review_4_position', title: 'scor_review_4_title' },
    },
  },
  improveAreas: {
    erectile: [
      { id: 1, name: 'f3_benefit1', icon: 'erectile' },
      { id: 2, name: 'f3_benefit2', icon: 'ejaculation', addGoal: true },
    ],
    ejaculation: [
      { id: 1, name: 'f3_benefit2', icon: 'ejaculation' },
      { id: 2, name: 'f3_benefit1', icon: 'erectile', addGoal: true },
    ],
    improve: [
      { id: 3, name: 'f3_benefit3', icon: 'prostate' },
      { id: 4, name: 'f3_benefit4', icon: 'confidence' },
      { id: 5, name: 'f3_benefit5', icon: 'relationship-happiness' },
    ],
  },
  homePage: [
    {
      id: 1,
      name: 'start_v6_answer_1',
      group: '25-34',
      value: 1,
      compatibilityScore: '87.1',
      image: '/images/v6_img_1.webp',
    },
    {
      id: 2,
      name: 'start_v6_answer_2',
      group: '35-44',
      value: 2,
      compatibilityScore: '87.8',
      image: '/images/v6_img_2.webp',
    },
    {
      id: 3,
      name: 'start_v6_answer_3',
      group: '45-55',
      value: 3,
      compatibilityScore: '96.7',
      image: '/images/v6_img_3.webp',
    },
    {
      id: 4,
      name: 'start_v6_answer_4',
      group: '55+',
      value: 4,
      compatibilityScore: '93',
      image: '/images/v6_img_4.webp',
    },
  ],
});

declare module '@nuxt/schema' {
  interface AppConfigInput {
    reviewsConfigs?: {
      reviews: number[]
      reviewsGoals: number[]
      reviewsList: Record<number, IReview>
      reviewsListV3: Record<number, IReviewV3Model>
    }
    improveAreas?: {
      erectile: ImprovementAreasModel[]
      ejaculation: ImprovementAreasModel[]
      improve: ImprovementAreasModel[]
    }
    homePage?: AgeAnswerModel[]
  }
}
